










import { defineComponent, reactive, toRefs, computed, ref, onMounted, PropType } from '@vue/composition-api';
import http from "../plugins/http";
import { Room } from "../modules/teacher/ResultDistributionList"

export interface Data {
  sheet_group_key: string
  room_id: string
  rooms: Room[]
}

export default defineComponent({
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheet_group_key: "",
      room_id: "",
      rooms: []
    });

    const toDistributionRoom = (room_id: number) => {
      context.root.$router.push(`/teacher_site/result_distribution_list/${state.sheet_group_key}/${room_id}`).catch(() => {});
      location.reload();
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      state.sheet_group_key = context.root.$route.params.sheet_group_key;
      state.room_id = context.root.$route.params.room_id;
      await http.get(`/api/result_distribution_list/get_rooms/${state.sheet_group_key}`).then(response => {
        state.rooms = response.data.rooms.map((x: any) => new Room(x));
      })
      .catch(error=>{
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。`);
        }
      });
    });

    return {
      ...toRefs(state),
      toDistributionRoom,
    };
  }
})
